export default __webpack_public_path__ + "static/scraps-5fb3c60430e656ef8c9b861666ca44b9.png";